export default __webpack_public_path__ + "static/media/expl-nn_08_EN.0735e6e9.png";